module.exports = __webpack_public_path__ + "img/college-graduate.4b58b006.png";